import { Button } from 'component/Button'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { userModal } from 'page/catalog/UserModal/store/UserModalStore'

export const CreateButton = observer(() => {
  const demo = useDemo()
  const { access } = demo.data.widget
  const store = userModal.it
  const disabled = !access

  const onCreate = useLatestCallback(async () => {
    store.step = 'create'
  })

  return <Button gap={8} height={48} primary action={onCreate} disabled={disabled}>
    <Icon name="add_circle" size={16} />
    <Typo>{i18n('CreateCustomer')}</Typo>
  </Button>
})
